module.exports = __webpack_public_path__ + "img/logo.bd102e12.png";